<script lang="ts">
	import BetaTag from './BetaTag.svelte';

	import { page } from '$app/stores';
	import GradientBorder from '$lib/util/GradientBorder.svelte';
	import LiveTag from './LiveTag.svelte';
	import EndedTag from './EndedTag.svelte';
	export let name: string;
	export let url: string;
	export let beta: boolean = false;
	export let live: boolean = false;
	export let ended: boolean = false;
</script>

{#if $page.url.pathname === url.split('?')[0]}
	<GradientBorder
		gradient="bg-fx-gradient-14"
		paddingClass="p-px"
		borderRadius="rounded-lg "
		outerClassList=""
		innerClassList="flex justify-center items-center bg-fx-black "
	>
		<div
			class="py-1 px-3 text-center cursor-pointer bg-fx-gradient-8 text-sm font-semibold text-fx-white rounded-lg whitespace-nowrap"
		>
			{name}
			{#if beta}<BetaTag />{/if}
			{#if live}<LiveTag />{/if}
			{#if ended}<EndedTag />{/if}
		</div>
	</GradientBorder>
{:else}
	<div
		class="py-1 px-3 text-center hover:bg-fx-grey-600 hover:bg-opacity-50 transition ease-in cursor-pointer rounded-lg whitespace-nowrap"
	>
		{name}
		{#if beta}<BetaTag />{/if}
		{#if live}<LiveTag />{/if}
		{#if ended}<EndedTag />{/if}
	</div>
{/if}
